// Options for the saved-search form's bounded selects. Price points mirror
// the listing page's hardcoded bands; bedrooms and yield are new facets that
// have no listing-page control yet.

export interface BoundOption {
  value: number;
  label: string;
}

const pounds = (value: number): string => `£${value.toLocaleString('en-GB')}`;

export const PRICE_BOUND_OPTIONS: BoundOption[] = [
  0, 125000, 250000, 500000, 750000, 1000000, 2000000, 5000000,
].map((value) => ({ value, label: pounds(value) }));

export const BEDROOM_BOUND_OPTIONS: BoundOption[] = [1, 2, 3, 4, 5, 6].map(
  (value) => ({ value, label: String(value) })
);

export const YIELD_BOUND_OPTIONS: BoundOption[] = [2, 4, 6, 8, 10, 12, 15].map(
  (value) => ({ value, label: `${value}%` })
);
